// extracted by mini-css-extract-plugin
module.exports = {"CourseDetail":"CourseDetail_CourseDetail__CI2Jz","CourseDetail__Detail":"CourseDetail_CourseDetail__Detail__8OP9U","CourseDetail__Time":"CourseDetail_CourseDetail__Time__N8AcN"};